// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__9ozko","fill":"ProgressBar_fill__iv5wv","label":"ProgressBar_label__EDoMD","valueLabel":"ProgressBar_valueLabel__3iwvK"};